// extracted by mini-css-extract-plugin
export default {"action":"OfferFileRow_action__nnAbK","link":"OfferFileRow_link__PJTae","delete":"OfferFileRow_delete__S14WV"};